import React, { useEffect, useMemo } from 'react';
import './styles.css';
import Aos from 'aos';
import 'aos/dist/aos.css';

const SectionSchedule = ({ theme }) => {
  const datas = [
    {
      id: '1',
      day: '',
      date: '18/11 - Viver melhor: saúde mental e fibrose cística',
      speakers: [
        {
          hora: '19h00',
          name: 'Verônica Stasiak',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Gastroenterologista',
          descriptionH3: 'Abertura',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '19h10',
          name: 'Dra. Katarinne Moraes',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Gastroenterologista',
          descriptionH3:
            'Adesão e Saúde Mental na Fibrose Cística: Compreendendo para melhor viver',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '19h30',
          name: 'Psi. Fernanda Pamplona',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Gastroenterologista',
          descriptionH3:
            'Conversando sobre saúde mental na fibrose cística + lançamento de cartilha!',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '19h50',
          name: 'Mediação Verônica Stasiak',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Gastroenterologista',
          descriptionH3: 'Interação com o público, perguntas e respostas',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '20h20',
          name: 'Mediação Verônica Stasiak',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Gastroenterologista',
          descriptionH3: 'Encerramento',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
      ],
    },
    {
      id: '2',
      day: '',
      date: '25/11 - Cuidando da mente: a fibrose crítica na infância, adolecência e vida adulta',
      speakers: [
        {
          hora: '19h00',
          name: 'Verônica Stasiak',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Medico',
          descriptionH3: 'Abertura',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '19h10',
          name: 'Dra. Debora Chong',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Medico',
          descriptionH3:
            'Saúde Mental na infância e adolescência de pessoas com fibrose cística',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '19h30',
          name: 'Dra. Carolina Severo',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Medico',
          descriptionH3:
            'Saúde Mental na fase adulta de pessoas com fibrose cística',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '19h50',
          name: 'Mediação Verônica Stasiak',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Medico',
          descriptionH3: 'Interação com o público, perguntas e respostas',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '20h20',
          name: 'Mediação Verônica Stasiak',
          // picture:
          // 'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          // profission: 'Medico',
          descriptionH3: 'Encerramento',
          // descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
      ],
    },
  ];

  function Tab({ data }) {
    return (
      <div className="de_tab tab_style_4 text-center">
        {data.map((item) => (
          <>
            <ul className="de_nav de_nav_dark">
              <button
                key={item.id}
                type="button"
                className={'tab-title tab-title--active'}
              >
                <h3>{item.day}</h3>
                <h4 style={{ fontSize: 16 }}>{item.date}</h4>
              </button>
            </ul>
            <div
              className="de_tab_content text-left"
              style={{ marginBottom: '20px' }}
            >
              <div
                key={item.id}
                className="tab-pane active"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <table className="schedule-table">
                  <thead>
                    <tr>
                      <th>Início</th>
                      {/* <th>Término</th> */}
                      {/* <th>Duração</th> */}
                      <th>Tema</th>
                      <th>Palestrante</th>
                    </tr>
                  </thead>
                  <tbody>
                    {item.speakers.map((speaker) => (
                      <tr key={speaker.id}>
                        <td className="sc-time">{speaker.hora}</td>
                        {/* <td>{speaker.termino}</td> */}
                        {/* <td>{speaker.tempo}</td> */}
                        <td className="sc-info">
                          <p className="description">{speaker.descriptionH3}</p>
                        </td>
                        <td className="sc-name">
                          <h4>{speaker.name}</h4>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ))}
      </div>
    );
  }

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      <section
        id="section-schedule"
        className={theme ? 'dark-mode' : 'light-mode'}
        aria-label="section-services-tab"
      >
        <div className="wm wm-border light" data-aos="fade-down">
          agenda
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3 text-center">
              <h1 data-aos="fade-up">Agenda</h1>
              <div className="separator">
                <span>
                  <i className="fa fa-square" />
                </span>
              </div>
              <div className="spacer-single" />
            </div>
            <div className="col-md-12">
              <Tab data={datas} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionSchedule;
